document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger missing');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('.tencel-section').forEach((section) => {
    const heading = section.querySelector('.tencel-heading');
    const text = section.querySelector('.tencel-text');
    const logo = section.querySelector('.tencel-logo');
    const words = section.querySelectorAll('.tencel-word');
    const button = section.querySelector('.tencel-button-wrapper');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    });

    // Heading (unchanged)
    if (heading) {
      tl.from(heading, {
        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: 'power3.out'
      });
    }

    // Text (unchanged)
    if (text) {
      tl.from(text, {
        opacity: 0,
        y: 30,
        duration: 0.6,
        ease: 'power3.out'
      }, '-=0.2');
    }

    if (logo) {
      tl.from(logo, {
        opacity: 0,
        scale: 0.7,
        filter: "blur(15px)",
        duration: 0.9,
        ease: 'power3.out'
      }, '-=0.2');
    }
    // WORDS — isolated animation (SAFE)
    if (words.length) {
      tl.fromTo(
        words,
        WORD_ANIMATION.from,
        WORD_ANIMATION.to,
        '-=0.2'
      );
    }

    // Button (unchanged)
    if (button) {
      tl.from(button, {
        opacity: 0,
        y: 20,
        duration: 0.4,
        ease: 'power3.out'
      }, '-=0.2');
    }
  });
});

/* Shopify Theme Editor support */
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.tencel-section');
  if (!section || typeof gsap === 'undefined') return;

  gsap.from(section.querySelectorAll(
    '.tencel-heading, .tencel-text, .tencel-logo, .tencel-word, .tencel-button-wrapper'
  ), {
    opacity: 0,
    y: 30,
    duration: 0.6,
    stagger: 0.15,
    ease: 'power3.out'
  });
});
const WORD_ANIMATION = {
  from: {
    opacity: 0,
    x: -40
  },
  to: {
    opacity: 1,
    x: 0,
    duration: 0.4,
    stagger: 0.15,
    ease: 'power3.out',
    clearProps: 'transform'
  }
};
